export abstract class Entity {
    id: number = 0;
}